<template>
  <div id="app">
    <!-- <NavTop/> -->
    <router-view></router-view>
    <Footer/>
  </div>
</template>

<script>
// import NavTop from './components/comcomponents/NavTop'
import Footer from './components/comcomponents/Footer'
import 'vant/lib/index.css'
export default {
  name: 'App',
  components: {
    Footer
  }
}
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
}
.home_box{
  margin-top:60px;
}
.julihe_bannerimg{
  width:100vw;
  vertical-align: middle;
}
.article_box{
  padding-bottom:5vh;
  padding-top:0.3rem;
}
.article_title{
  color:#333;
  font-size: 1.3rem;
  font-weight: bold;
  text-align: center;
  padding-top:1vh;
  padding-bottom: 1vh;
  margin-left: 5%;
  margin-right: 5%;
}
.article_p{
  color:#0295F9;
  font-size:0.8rem;
  padding-top:0.3rem;
  padding-bottom:0.3rem;
  text-align: center;
  margin-left: 5%;
  margin-right: 5%;
}
.iconfont{
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue